import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DexLpWidget} from '../dex-lp-widget';
import {DexLpWidgetSettings} from './dex-lp-widget-settings';

interface SettingsFormValue {
    title: string;
}

@Component({
    selector:    'dex-lp-widget-settings',
    templateUrl: './dex-lp-widget-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone:  false
})
export class DexLpWidgetSettingsComponent extends WidgetImplSettingsComponentBase<DexLpWidget> {

    @Input()
    public override widget: DexLpWidget;

    public form: TypedForm<SettingsFormValue>;

    protected override buildForm(): void {
        const settings: DexLpWidgetSettings = this.widget.implementationInstance.settings;

        const controls: TypedFormOwnControls<SettingsFormValue> = {
            title:   this.createTitleFormControl(settings)
        };

        this.form = new FormGroup(controls) as TypedForm<SettingsFormValue>;
    }

}
